import {
  Box,
  Link,
  Typography,
  Dialog,
  DialogContent,
  Grid,
  DialogTitle,
  IconButton,
  TextareaAutosize,
  styled,
} from "@mui/material";
import React, { useEffect, useState } from 'react';
import styles from './scMembers.module.scss';
import constants from "../../config/constants.json";
import Pagination from '../common/pagination/pagination';
import { CommonButton, CommonOutlinedButton, CustomCheckbox, CustomInputLabel } from '../common/StyledComponents/StyledFields';
import CloseIcon from "@mui/icons-material/Close";
import { BeatLoader, BounceLoader, ClipLoader } from 'react-spinners';
import { apiRequest, catchErrorMessageHandler } from "../../infrastructure/backendService";
import ErrorPopup from "../common/ErrorPopup";
import toast, { Toaster } from "react-hot-toast";
import apiPath from "../../config/apiPaths.json";
import ToastComponent from "../common/toastComponent";
import CustomizedSwitch from "../common/CustomToggle/CustomToggle";
import { isNil } from "lodash";



interface NewSCMProps {
  searchItems: any[]; // Replace any with your actual type
  totalRecords: number;
  pageNumber: number;
  setPageNumber: React.Dispatch<React.SetStateAction<number>>;
  searchDataApi: () => void;
  setIsNewScmParam: React.Dispatch<React.SetStateAction<boolean>>;
  showTableComponent: boolean;
}

const NewSCMComponent = (props: NewSCMProps) => {
  // const [searchItems, setSearchItem] = useState([]);
  // const [pageNumber, setPageNumber] = useState<number>(1);
  // const [totalRecords, setTotalRecords] = useState<number>(0);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [categoryId, setCategoryId] = useState<null | number>(null);
  const [selectedUsernames, setSelectedUsernames] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const [makeScmButton, setMakeScmButton] = useState<boolean>(true);
  const [userName, setUserName] = useState("");
  const [isScmView, setIsScmView] = useState<boolean>(false);
  const [selectedUserName, setSelectedUserName] = useState("");
  const [openUserDetailsDialog, setOpenUserDetailsDialog] = useState(false);
  const [loadingBounce, setLoadingBounce] = useState(false);
  const [userDetailsList, setUserDetailsList] = useState<any>({});
  const [userDetailsDevoteeCategoryList, setUserDetailsDevoteeCategoryList] = useState<any>([]);


  const handleToggleChange = (field: string, value: boolean) => {
    setIsScmView(value);
    props.setIsNewScmParam(value);
  };

  const handleConfirmationDialogClose = () => {
    setOpenConfirmationDialog(false);
  };

  const handleConfirmationDialogOpen = () => {
    setOpenConfirmationDialog(true);
  };

  const handleSuccessDialogClose = () => {
    setOpenSuccessDialog(false);
  };

  const handleProceed = () => {
    getUserCategoryIdApi();
  };

  useEffect(() => {
    // Clear selected rows and usernames when searchItems change
    setSelectedRows([]);
    setSelectedUsernames([]);
  }, [props.searchItems]);

  const getUserCategoryIdApi = () => {
    // setLoading(true);
    apiRequest({
      method: "GET",
      endpoint: apiPath.scmGetCatergoriesApi,
      //   body: JSON.stringify(reqBody),
      includeToken: true,
      params: {
        scm: true,
        // mode: selectedMode,
        // page: pageNumber - 1,
        // size: pageSize,
      },
    })
      .then((res) => {
        let categoryIdList = res.data.content;
        // Iterate through categoryIdList
        categoryIdList.forEach((category: any) => {
          if (category.name === "Steering Commitee Member - New") {
            // Set categoryId if the name is "New"
            setCategoryId(category.id);
          }
        });
      })
      .catch((err) => {
        console.log(err, "error")
        //  setLoading(false);
        //  toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
        //    duration: constants.TOAST_POPUP_DURATION,
        //  });
      });
  };

  useEffect(() => {
    if (categoryId) {
      MakeNewScmApiCall();
    }
  }, [categoryId]);

  const MakeNewScmApiCall = () => {
    setIsLoading(true);
    const reqBody = {
      username: selectedUsernames.toString(),
      categoryId: categoryId,
    };
    apiRequest({
      method: "POST",
      endpoint: apiPath.scmUserCategoryApi,
      includeToken: true,
      body: JSON.stringify(reqBody),
      params: {
        scm: true,
        // mode: selectedMode,
        // page: pageNumber - 1,
        // size: pageSize,
      },
    })
      .then((res) => {
        setIsLoading(false);
        setOpenConfirmationDialog(false);
        setOpenSuccessDialog(true);
        setCategoryId(null);
        setUserName(res.data.username);
        props.searchDataApi();
        // getPoojaHallListApi();
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  };

  const userDetailsApiCall = (row: any) => {
    setLoadingBounce(true);
    apiRequest({
      method: "GET",
      endpoint: `${apiPath.devoteeServiceUserDetailsApi}/${row.username}`,
      includeToken: true,
    })
      .then((res) => {
        console.log(res.data, "res.dataaaa");
        setUserDetailsList(res?.data);
        setUserDetailsDevoteeCategoryList(res?.data?.categoryNames)
        setLoadingBounce(false);
      })
      .catch((err) => {
        console.log(err);
        setLoadingBounce(false);
      });
  };

  const handleDetailsClick = (item: any) => {
    setSelectedUserName(item.username);
    setOpenUserDetailsDialog(true);
    userDetailsApiCall(item);
    console.log(item, "rowwww")
  }

  const handleUserDetailsDialogClose = () => {
    setOpenUserDetailsDialog(false);
  };

  const handleCheckboxChange = (username: string) => {
    setSelectedRows([]);
    setSelectedUsernames([]);
    setMakeScmButton(false);
    const selectedRow = props.searchItems.find(
      (row: any) => row.username === username
    );

    if (selectedRow) {
      setSelectedRows([selectedRow]);
      setSelectedUsernames([username]);
    }
  };

  const devoteeListItemTable = () => {
    // Filtered items based on the toggle state
    // const filteredItems = isScmView ? props.searchItems.filter(item => item.categoryName !== null) : props.searchItems.filter(item => item.categoryName === null);

    if (props.searchItems.length === 0) {
      return <Typography sx={{ margin: "24px auto", color: "red", fontSize: "28px" }}><b>{constants.NO_RECORDS_FOUND}</b></Typography>;
    }

    return (
      <>
        <div style={{ overflowY: "auto" }}>
          <table className={styles.tableContainer}>
            <thead>
              <tr className={styles.headerTableRow}>
                <th className={styles.tableHorizontal}></th>
                <th className={styles.tableHorizontal}>Username</th>
                <th className={styles.tableHorizontal}>Name</th>
                <th className={styles.tableHorizontal}>Address</th>
                <th className={styles.tableHorizontal}>Email</th>
                <th className={styles.tableHorizontal}>Phone No</th>
                <th className={styles.tableHorizontal}>Details</th>
                <th className={styles.tableHorizontal}>Status</th>
              </tr>
            </thead>
            <tbody className={styles.tableBody} id="searchScmData">
              {props.searchItems.map((item: any) => (
                <tr key={item.username} className={styles.tableRow}>
                  <td className={styles.tableDiagonal}>
                    {item.categoryName === null && (
                      <CustomCheckbox
                        checked={selectedRows.some((selectedRow) => selectedRow.username === item.username)}
                        onChange={() => handleCheckboxChange(item.username)}
                      />
                    )}
                  </td>
                  <td
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                    }}
                  >
                    {item.username}
                  </td>
                  <td
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                    }}
                  >
                    {`${item.firstname} ${item.lastname}`}
                  </td>
                  <td
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                    }}
                  >
                    {item.address}
                  </td>
                  <td
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                    }}
                  >
                    {item.email}
                  </td>
                  <td
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                    }}
                  >
                    {item.phonework}
                  </td>
                  <td
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                      cursor: "pointer",
                      textDecoration: "underline",
                    }}
                    onClick={() => handleDetailsClick(item)}
                  >
                    <p>Details</p>
                  </td>
                  <td
                    className={styles.tableDiagonal}
                    style={{ color: "green", fontWeight: 600 }}
                  >
                    {item.categoryName}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {props.totalRecords > 20 ? (
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              marginRight: "10px",
              marginTop: "3px",
            }}
          >
            <Pagination
              items={props.totalRecords}
              itemsPerPage={20}
              setPageNumber={props.setPageNumber}
              pageNumber={props.pageNumber}
            />
          </div>
        ) : (
          ""
        )}
        {!isScmView &&
          <Grid sx={{ marginTop: "10px" }}>
            <CommonButton onClick={handleConfirmationDialogOpen} disabled={makeScmButton}>Make New SCM</CommonButton>
          </Grid>}
      </>
    );
  };




  const confirmationDialog = () => {
    return (
      <>
        <Dialog
          open={openConfirmationDialog}
          onClose={handleConfirmationDialogClose}
          aria-labelledby="cancel-dialog-title"
        >
          <div
            style={{
              backgroundColor: "#882E14",
            }}
          >
            <DialogTitle
              sx={{ fontWeight: 700, fontSize: "16px", color: "white" }}
            >
              {"New SC Member"}
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={handleConfirmationDialogClose}
              sx={{
                position: "absolute",
                right: 24,
                top: 8,
                color: (theme: any) => theme.palette.grey[500],
              }}
            >
              <CloseIcon sx={{ color: "white" }} />
            </IconButton>
          </div>
          <DialogContent>
            <Typography style={{ fontWeight: "400", marginBottom: "20px" }}>
              You are about to make <b>{selectedUsernames}</b> as a Steering Committee Member
            </Typography>
            <div style={{ float: "right" }}>
              <CommonOutlinedButton
                onClick={handleConfirmationDialogClose}
                sx={{ marginRight: "10px" }}
              >
                cancel
              </CommonOutlinedButton>
              <CommonButton onClick={handleProceed}>
                {isLoading ? (
                  <>
                    <ClipLoader color="#fff" loading={isLoading} size={15} />
                    <span
                      style={{
                        marginLeft: "8px",
                        fontSize: "15px",
                        textAlign: "center",
                      }}
                    >
                      Loading...
                    </span>
                  </>
                ) : (
                  "Yes"
                )}
              </CommonButton>
            </div>
          </DialogContent>
        </Dialog>
      </>
    )
  }

  const SuccessDialog = () => {
    return (
      <>
        <Dialog
          open={openSuccessDialog}
          onClose={handleSuccessDialogClose}
          aria-labelledby="cancel-dialog-title"
        >
          <div
            style={{
              backgroundColor: "#882E14",
              width: "562px",
            }}
          >
            <DialogTitle
              sx={{ fontWeight: 700, fontSize: "16px", color: "white" }}
            >
              {"SC Member Status"}
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={handleSuccessDialogClose}
              sx={{
                position: "absolute",
                right: 24,
                top: 8,
                color: (theme: any) => theme.palette.grey[500],
              }}
            >
              <CloseIcon sx={{ color: "white" }} />
            </IconButton>
          </div>
          <DialogContent sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <img src="/images/successImage.svg" />
            <Typography style={{ fontWeight: "400", marginBottom: "20px" }}>
              <b>{userName}</b> is a New Steering Committee Member
            </Typography>
          </DialogContent>
        </Dialog>
      </>
    )
  }

  const toggleComponent = () => {
    return (
      <Box
        sx={{
          pt: "17px",
          display: "flex",
          alignItems: "center",
          height: "54px",
        }}
      >
        <Typography className={styles.toggle_priest_text} mr="13px">
          Devotee
        </Typography>
        <CustomizedSwitch isChecked={isScmView} handleChange={handleToggleChange} fieldName="" />
        <Typography className={styles.toggle_priest_text} ml="13px">
          SCM New
        </Typography>
      </Box>
    )
  }

  const userDetailsTableComponent = () => {
    const categories = Array.isArray(userDetailsDevoteeCategoryList) ? userDetailsDevoteeCategoryList : [];

    // Map categories to JSX elements with <br/> separators
    const categoriesWithLineBreaks = categories.map((category, index) => (
      <div key={index}>
        {category}{index < categories.length - 1 && <br />}
      </div>
    ));
    return (
      <Grid>
        {/* {userDetailsList?.map((user: any, index: any) => ( */}
        <table className={styles.tableDetailsTableContainer}>
          <tbody>
            <tr className={styles.headerTableRow}>
              <td className={styles.headerTableColumn}>Sign-in Name</td>
              <td className={styles.contentTableColumn}>{userDetailsList.username}</td>
            </tr>
            <tr className={styles.headerTableRow}>
              <td className={styles.headerTableColumn}>Name</td>
              <td className={styles.contentTableColumn}>{`${userDetailsList.firstName} ${userDetailsList.middleName ? userDetailsList.middleName + ' ' : ''} ${userDetailsList.lastName}`} </td>
            </tr>
            <tr className={styles.headerTableRow}>
              <td className={styles.headerTableColumn}>Address</td>
              <td className={styles.contentTableColumn}>{userDetailsList.address === null || userDetailsList.address === "" ? "-" : userDetailsList.address}</td>
            </tr>
            <tr className={styles.headerTableRow}>
              <td className={styles.headerTableColumn}>Home Phone</td>
              <td className={styles.contentTableColumn}>{userDetailsList.phoneResidence === null || userDetailsList.phoneResidence === "" ? "-" : userDetailsList.phoneResidence}</td>
            </tr>
            <tr className={styles.headerTableRow}>
              <td className={styles.headerTableColumn}>Work Phone</td>
              <td className={styles.contentTableColumn}>{userDetailsList.phoneWork === null || userDetailsList.phoneWork === "" ? "-" : userDetailsList.phoneWork}</td>
            </tr>
            <tr className={styles.headerTableRow}>
              <td className={styles.headerTableColumn}>Email</td>
              <td className={styles.contentTableColumn}>{userDetailsList.email === null || userDetailsList.email === "" ? "-" : userDetailsList.email}</td>
            </tr>
            <tr className={styles.headerTableRow}>
              <td className={styles.headerTableColumn}>Category</td>
              <td className={styles.contentTableColumn}><span style={{ fontWeight: 600 }}>{userDetailsList.defaultCategoryName}</span><br />
                {categoriesWithLineBreaks}</td>
            </tr>
            <tr className={styles.headerTableRow}>
              <td className={styles.headerTableColumn}>Date of Registration</td>
              <td className={styles.contentTableColumn}>{userDetailsList.dateOfRegistration === null || userDetailsList.dateOfRegistration === "" ? "-" : userDetailsList.dateOfRegistration}</td>
            </tr>
            <tr className={styles.headerTableRow}>
              <td className={styles.headerTableColumn}>Update Date</td>
              <td className={styles.contentTableColumn}>{userDetailsList.updateDate === null || userDetailsList.updateDate === "" ? "-" : userDetailsList.updateDate}</td>
            </tr>
          </tbody>
        </table>
        {/* ))} */}
      </Grid>
    );
  };

  const userDetailsDialogComponent = () => {
    return (
      <>
        <Dialog
          open={openUserDetailsDialog}
          onClose={handleUserDetailsDialogClose}
          aria-labelledby="cancel-dialog-title"
        >
          <div
            style={{
              backgroundColor: "#882E14",
              width: "600px",
            }}
          >
            <DialogTitle
              sx={{ fontWeight: 700, fontSize: "16px", color: "white" }}
            >
              {"Devotee Details"}
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={handleUserDetailsDialogClose}
              sx={{
                position: "absolute",
                right: 24,
                top: 8,
                color: (theme: any) => theme.palette.grey[500],
              }}
            >
              <CloseIcon sx={{ color: "white" }} />
            </IconButton>
          </div>
          <DialogContent sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            {/* {userDetailsTableComponent()} */}
            {loadingBounce ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <BounceLoader color="#22A699" loading={loadingBounce} size={45} />
                <span
                  style={{
                    marginLeft: "8px",
                    fontSize: "15px",
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  Please wait...
                </span>
              </div>
            ) : (
              <div>
                {userDetailsTableComponent()}
                {/* {donationSummeryList.length > 0 ? (
                  poojaDetailsComponent()
                ) : (
                  <Typography sx={{ textAlign: "center" }}>No Data</Typography>
                )} */}
              </div>
            )}
          </DialogContent>
        </Dialog>
      </>
    )
  }

  return (
    <Box>
      <ToastComponent />
      {confirmationDialog()}
      {SuccessDialog()}
      {userDetailsDialogComponent()}
      <Grid>
        {/* {props.searchItems.length != 0 && toggleComponent()} */}
        {toggleComponent()}
        {props.showTableComponent ? (
          props.searchItems.length > 0 ? (
            devoteeListItemTable()
          ) : (
            <Typography sx={{ margin: "24px auto", color: "red", fontSize: "28px" }}>
              <b>{constants.NO_RECORDS_FOUND}</b>
            </Typography>
          )
        ) : null}

        {/* {devoteeListItemTable()} */}
      </Grid>
    </Box>
  )
}

export default NewSCMComponent